import { ConfirmDialog } from "~/components/ConfirmDialog";

type LogoutConfirmDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  pending?: boolean;
};

/**
 * Confirmar el cierre de sesión.
 *
 * Antes traía un antetítulo, un ícono en recuadro, un título de 34px y un cartelito verde de
 * "todo tu progreso está a salvo" — y pintaba CANCELAR como el botón principal, oscuro y
 * grande, mientras confirmar quedaba como un texto suelto. Uno venía a cerrar sesión y el botón
 * que saltaba a la vista era el que no la cerraba.
 *
 * Queda lo que hace falta para decidir: qué va a pasar, que no se pierde nada, y dos botones.
 * La forma la pone `ConfirmDialog`, que es la misma para todos.
 */
export function LogoutConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  pending = false,
}: LogoutConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="¿Cerrar sesión?"
      description="Tu avance queda guardado. Podés volver a entrar cuando quieras."
      confirmLabel="Cerrar sesión"
      cancelLabel="Seguir acá"
      onConfirm={onConfirm}
      destructive
      pending={pending}
      pendingLabel="Cerrando…"
      overlayClassName="z-[10010]"
      contentClassName="z-[10020]"
    />
  );
}
